import React, { useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import { SEO, PAGE_DATA } from './consts'
import QuestionItem from './QuestionItem'
import Img from '../../shared/Img'
import WithSeoOverrides from 'src/components/shared/WithSeoOverride'

const ClientQuestions = ({ clientQuestions }) => {
  const [marked, setMarked] = useState(null)

  const handleCollapseChange = useCallback(
    (key) => {
      const value = key === marked ? null : key
      setMarked(value)
    },
    [marked]
  )

  return (
    <>
      <WithSeoOverrides {...SEO} />
      <div className="m-auto max-w-1400">
        <div className="overflow-x-hidden">
          <div className="bg-gray-410 py-8 text-left lg:py-12">
            <div className="flex flex-col items-center justify-center px-8 text-white">
              <Img
                src="/next-assets/client-faq.webp"
                priority={true}
                alt="Blog Credit Score Faqs"
                layout="fill"
                isBackgroundImage={true}
                objectFit="cover"
                className="h-80 w-full max-w-1400 sm:h-57 md:h-80 lg:scale-y-125"
                imgClassName="object-center"
              />
              <h1
                className="relative mt-12 mb-2 text-left text-2xl leading-tight md:mt-18 md:mb-4 md:text-4xl md:leading-normal"
                data-testid="title"
              >
                {PAGE_DATA.title}
              </h1>
              <p
                className="relative mb-5 text-center text-xl md:mb-6"
                data-testid="subTitle"
              >
                {PAGE_DATA.subTitle}
              </p>
            </div>
          </div>
          <div className="bg-blue-700 px-5 py-6 md:px-5 md:py-12">
            <p
              className="w-content pb-6 text-sm text-white"
              data-testid="blueSectionData"
            >
              {PAGE_DATA.blueSectionData}
            </p>
          </div>
          <p
            className="w-content whitespace-pre-line px-8 py-12 text-sm leading-normal text-gray-400 md:pt-16 md:pb-20 lg:px-0"
            data-testid="textContent"
          >
            {PAGE_DATA.textContent}
          </p>
          <div className="m-auto max-w-2xl px-6 py-10">
            {clientQuestions.map((question) => (
              <QuestionItem
                marked={marked}
                key={question.key}
                question={question}
                onClick={handleCollapseChange}
              />
            ))}
            <div className="border-t-2 border-gray-200 py-3" />
          </div>
        </div>
      </div>
    </>
  )
}

ClientQuestions.propTypes = {
  clientQuestions: PropTypes.array.isRequired,
}

export default ClientQuestions
